<template>
  <div class="home">

    <dashboard/>
  </div>
</template>

<script>
import dashboard from "@/components/PurchaseBonds.vue";

export default {
  name: "PurchaseBonds",
  components: {
    dashboard
  }
};
</script>
